module.exports = __webpack_public_path__ + "static/media/rate-5.d3dd7ea4.svg";